import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Hammer, FlaskConical, MapPin, TrendingUp, CheckCircle2 } from 'lucide-react';
const benefits = [{
  icon: Hammer,
  title: 'Resultado Profesional con Herramientas Caseras',
  text: 'Aprendé a usar un taladro común y una lijadora de mano para lograr acabados de u$s 500+.'
}, {
  icon: FlaskConical,
  title: 'Control Total de la Química',
  text: 'Olvidate de las burbujas y las piezas pegajosas. Te enseño el ratio exacto y el control térmico para el clima uruguayo.'
}, {
  icon: MapPin,
  title: 'Guía de Proveedores Locales',
  text: 'No busques más en Amazon. Te digo dónde comprar la mejor resina, pigmentos y madera nacional (Eucalipto, Olivo, etc.) al mejor precio en UY.'
}, {
  icon: TrendingUp,
  title: 'Ingreso Extra Inmediato',
  text: 'Convertí un hobby en un negocio. Una tabla de picar de resina se vende por el triple de su costo de materiales en ferias de diseño o IG.'
}];
const carouselImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/x2f2Xng3qXMBfxw3SjJg4w/255aa2af78ab3f5c2cfb2e7301a3e659.jpg',
  alt: 'Tablas, cucharas y piezas de cocina en madera con resina epoxi oceánica'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/p7MYTQjpmUZh5oHGejSXe1/642dbd48fc42d64d1135da1c09ca1761.jpg',
  alt: 'Cuadro artístico en resina epoxi efecto playa con caracoles'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9fg8Jibt5RnHyZagDbZ3ng/2055f3b0a5d3f920342662c1fede6325.jpg',
  alt: 'Reloj de pared artesanal en resina epoxi efecto olas del mar'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oTi1C81yD9pbXZeLjEELU7/f31b12fbaecc0fc3fe638a4f49752a15.jpg',
  alt: 'Tablas de picar artesanales en madera con resina epoxi'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eNmPKRHPu2MnjxPs2k2rG9/posteo2.jpg',
  alt: 'Joyería y accesorios con resina epoxi cristalina'
}];
export function Benefits() {
  return <section className="py-8 sm:py-14 bg-[#0a0e17] relative overflow-hidden" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 sm:mb-10" data-id="element-3">
          <h2 className="text-2xl md:text-4xl font-bold text-white" data-id="element-4">
            Lo que vas a lograr
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-12" data-id="element-5">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -30 : 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="flex gap-4 sm:gap-6 items-start group" data-id="element-6">
              <div className="flex-shrink-0" data-id="element-7">
                <div className="w-12 h-12 rounded-full bg-[#1e6bb8]/10 flex items-center justify-center border border-[#1e6bb8]/30 group-hover:border-[#d4a853]/50 group-hover:bg-[#d4a853]/10 transition-all duration-300" data-id="element-8">
                  <CheckCircle2 className="w-6 h-6 text-green-500 group-hover:text-green-400 transition-colors" data-id="element-9" />
                </div>
              </div>
              <div data-id="element-10">
                <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3 group-hover:text-[#d4a853] transition-colors" data-id="element-11">
                  {benefit.title}
                </h3>
                <p className="text-[#9ca3af] leading-relaxed" data-id="element-12">{benefit.text}</p>
              </div>
            </motion.div>)}
        </div>
      </div>

      {/* Auto-scrolling Image Carousel */}
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="mt-8 sm:mt-12 relative" data-id="element-13">
        <p className="text-center text-[#d4a853] font-semibold uppercase tracking-wider text-xs sm:text-sm mb-4 sm:mb-6" data-id="element-14">
          ¿No te gustaría crear estas increíbles piezas con tus propias manos?
        </p>

        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-r from-[#0a0e17] to-transparent z-10 pointer-events-none" data-id="element-15" />
        <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-l from-[#0a0e17] to-transparent z-10 pointer-events-none" data-id="element-16" />

        <div className="flex overflow-hidden" data-id="element-17">
          <div className="flex animate-marquee gap-4 sm:gap-6" data-id="element-18">
            {[...carouselImages, ...carouselImages].map((img, index) => <div key={index} className="flex-shrink-0 w-56 sm:w-72 h-36 sm:h-48 rounded-xl overflow-hidden border border-[#ffffff]/10" data-id="element-19">
                <img src={img.src} alt={img.alt} className="w-full h-full object-cover" loading="lazy" data-id="element-20" />
              </div>)}
          </div>
        </div>
      </motion.div>
    </section>;
}